import { render } from "./AssetDetailsView.vue?vue&type=template&id=63fd8246&scoped=true&ts=true"
import script from "./AssetDetailsView.vue?vue&type=script&lang=ts"
export * from "./AssetDetailsView.vue?vue&type=script&lang=ts"

import "./AssetDetailsView.vue?vue&type=style&index=0&id=63fd8246&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63fd8246"]])

export default __exports__